// FNP-79: create / update mutations include the FNP-76 programmatic-
// provisioning input fields. The schema accepts them as optional, so the
// legacy admin-create flow that omits them continues to work.

const APPLICATION_RESPONSE_FIELDS = `
    id
    name
    description
    url
    logoUrl
    applicationCategory
    applicationStatus
    displayName
    businessDomain
    applicationType
    parentDomainName
    subdomain
    deploymentAccountGroupId
    workflowId
    stepFunctionsExecutionArn
    statusReason
    progress { currentStep completedSteps failedStep }
`;

export const createApplication = `
    mutation createApplication($input: CreateApplicationInput!) {
        createApplication(input:$input) {
            ${APPLICATION_RESPONSE_FIELDS}
    }
}`;

export const updateApplication = `
    mutation updateApplication($input: UpdateApplicationInput!) {
        updateApplication(input:$input){
            ${APPLICATION_RESPONSE_FIELDS}
        }
}`;

export const deleteApplication = `
    mutation deleteApplication($input: DeleteApplicationInput!) {
        deleteApplication(input:$input) {
            id
        }

}`;
